<template>
  <div ref="cont" class="cont">
    <GrcDB ref="GRCDB"></GrcDB>      
    <GrcFilePasswordInput ref="FilePasswordInput"></GrcFilePasswordInput>
  </div>
</template>

<script>

import Vue from 'vue';
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcFilePasswordInput from '../GrcComponents/GrcFilePasswordInput.vue'
//import pdfjsLib from "pdfjs-dist/build/pdf";
//pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdn.jsdelivr.net/npm/pdfjs-dist@2.6.347/build/pdf.worker.min.js";

export default {
  name: 'GrcDocUtils',
  components:
  {
    GrcDB,
    GrcFilePasswordInput
  },
  props: {
  },
  data () {
    return {

        FileData: "",
        FileType: "",
        MaxWidth:0,
        MaxHeight:0,
        Greyscale:false,

        pdfjsLib:null,
        _PDF_DOC:null,
        _CURRENT_PAGE:null,
        _TOTAL_PAGES:null,
        _PAGE_RENDERING_IN_PROGRESS:0,

        PDF_IMAGES:[],
        CurrentPageNo:-1,
        PdfImagesOK_Count:0,
        OpenPdfError:"",
        PdfSigned: false,

        PromiseResultObject: null
    }
  },
  watch : {
  },

  created: function()
  {
  },
  computed: {
  },
  updated: function() {

  },

  mounted: function () {
    this._CANVAS = document.createElement('canvas');

    import("pdfjs-dist").then((pdfjsLib) => {
       this.pdfjsLib = pdfjsLib;
       this.pdfjsLib.GlobalWorkerOptions.workerSrc = gPdfWorkerPath; //"https://cdn.jsdelivr.net/npm/pdfjs-dist@2.6.347/build/pdf.worker.min.js";
    });    
  },

  destroyed: function()
  {
  },


  methods: {

    Resize(pFileData, pFileType, pMaxWidth, pMaxHeight, pGreyscale)
    {
        var self = this;

        this.FileData = pFileData;
        this.FileType = pFileType;
        this.MaxWidth = pMaxWidth;
        this.MaxHeight = pMaxHeight;
        this.Greyscale = pGreyscale;

        var mt = "";
        if (this.FileType == "jpg") { mt = "data:image/jpeg;base64,"; }
        if (this.FileType == "png") { mt = "data:image/png;base64,"; }


        var image = new Image();
        image.src= mt + pFileData;

        image.addEventListener("load", function () {
            self.CreateResizedImage(image);
        });

        return new Promise((resolve, reject) => {
            this.PromiseResultObject = resolve;
    });

    },

    CreateResizedImage(image)
    {

        //console.log(image.src);

        var pMaxWidth = this.MaxWidth;
        var pMaxHeight = this.MaxHeight;

        if (image.width > image.height)
        {
            pMaxWidth = this.MaxHeight;
            pMaxHeight = this.MaxWidth;
        }

        if ((image.width<pMaxWidth)&&(image.height<pMaxHeight))
        {
            pMaxWidth = image.width;
            pMaxHeight = image.height;
        }

        var canvas, ctx, thumbnail, thumbnailScale, thumbnailWidth, thumbnailHeight;
        // create an off-screen canvas
        canvas = document.createElement('canvas');
        ctx = canvas.getContext('2d');

        thumbnailScale = (image.width / image.height) > (pMaxWidth / pMaxHeight) ?
            pMaxWidth / image.width :
            pMaxHeight / image.height;
        thumbnailWidth = image.width * thumbnailScale;
        thumbnailHeight = image.height * thumbnailScale;

        canvas.width = thumbnailWidth;
        canvas.height = thumbnailHeight;

        ctx.drawImage(image, 0, 0, thumbnailWidth, thumbnailHeight);

        var result = { data: canvas.toDataURL('image/jpeg', 100).split(',').pop(), width: canvas.width, height:canvas.height };

        if (this.Greyscale == false)
        {
            this.SendResult(result);
            return;
        }

        let imgData = ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height);
        let pixels = imgData.data;
        for (var i = 0; i < pixels.length; i += 4) {

            let lightness = parseInt((pixels[i] + pixels[i + 1] + pixels[i + 2]) / 3);

            pixels[i] = lightness;
            pixels[i + 1] = lightness;
            pixels[i + 2] = lightness;
        }
        ctx.putImageData(imgData, 0, 0);

        var result = { data: canvas.toDataURL('image/jpeg', 100).split(',').pop(), width: canvas.width, height:canvas.height };

        this.SendResult(result);
    },      


    SendResult(pValue)
    {
        this.PromiseResultObject(pValue);
    },

    GetSplitPdfImages()
    {
        return this.PDF_IMAGES;
    },

    IsPdfSigned()
    {
        return this.PdfSigned;
    },

    async OpenPdf(pFileData, pPassword)
    {
        var self = this;

        this._PDF_DOC = null;
        this.PdfSigned = false;

        this.OpenPdfError = "";
        var Sikeres = false;

        try 
        {
            var base64Index = pFileData.indexOf(';base64,');
            if (base64Index >= 0)
            {
                
                base64Index = base64Index + 8;
                pFileData = pFileData.substring(base64Index);
            }
            
            var raw = window.atob(pFileData);
            var rawLength = raw.length;
            var array = new Uint8Array(new ArrayBuffer(rawLength));

            for(var i = 0; i < rawLength; i++) {
                array[i] = raw.charCodeAt(i);
            }

            let loadingTask = this.pdfjsLib.getDocument({ data: array, password: pPassword });
            this._PDF_DOC = await loadingTask.promise;    

            Sikeres = true;
        }
        catch(error) {
            this.OpenPdfError = error.message;
        }

        if (Sikeres)
        {
            try 
            {
                var PageCount = this._PDF_DOC.numPages;
                for(var i=0; i<PageCount; i++)
                {
                    var page = await this._PDF_DOC.getPage(i+1);

                    await page.getAnnotations().then(function(annotations) {
                        //console.log('annotations loaded');
                        for (let ann = 0; ann < annotations.length; ann++) 
                        {
                            if (annotations[ann].fieldType == "Sig") { self.PdfSigned = true; }
                            //console.log(annotations[ann]);
                        }
                    });
                    
                }
            }
            catch(error) {
                console.log(error.message);
            }
        }

        return Sikeres;
    },

    async InputPdfPassword(pFileData, pFileName)
    {
        var Jelszo = "";
        var result = { Sikeres:false, Jelszo:"" };

        if (await this.OpenPdf(pFileData, Jelszo))
        {
            result.Sikeres = true;
            result.Jelszo = Jelszo;
            return result;
        }

        var DialogResult = "";
        var Password = "";

        var p = grccomp_dialog_yesno_GetDefaults("Jelszó a fájl megnyitásához", pFileName);             
        p.height = 250;
        p.width = 300;
        p.padding_top = 200;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        
        var ShowInput = true;

        while(ShowInput)
        {
            await this.$refs.FilePasswordInput.ShowDialog(p).then(res => { DialogResult = res.btnres; Password = res.password }); 

            if (DialogResult == "NO")
            {
                ShowInput = false;
            }
            else
            {            
                if (await this.OpenPdf(pFileData, Password))
                {
                    result.Sikeres = true;
                    result.Jelszo = Password;
                    ShowInput = false;
                }
            }
        }

        return result;
    },
    

    async SplitPdf(pFileData, pMaxWidth, pMaxHeight, pGreyscale, pPassword) 
    {
        this.PDF_IMAGES = [];
        this.CurrentPageNo = -1;
        this.PdfImagesOK_Count = 0;
        this._PDF_DOC = null;

        if (await this.OpenPdf(pFileData, pPassword) == false)
        {
            return false;
        }

        this._TOTAL_PAGES = this._PDF_DOC.numPages;

        for(var i=0; i<this._TOTAL_PAGES; i++)
        {
            this.PDF_IMAGES.push({ data: "", width:0, height:0 });
        }

        for(var i=0; i<this._TOTAL_PAGES; i++)
        {
            await this.GetPdfPageImage(i+1, pMaxWidth, pMaxHeight, pGreyscale);
        }
        
        return (this._TOTAL_PAGES == this.PdfImagesOK_Count);
    },

    async GetPdfPageImage(pPageNo, pMaxWidth, pMaxHeight, pGreyscale)
    {
        var self = this;
        this.CurrentPageNo = pPageNo;

        this.PromiseResultObject = null;

        try {
            var page = await this._PDF_DOC.getPage(pPageNo);
        }
        catch(error) {
            alert(error.message);
        }

        var scale_value = 1;
        var viewport = page.getViewport({scale:scale_value});

        if (viewport.width > viewport.height)
        {
            pMaxWidth = pMaxHeight;
        }

        scale_value = pMaxWidth / viewport.width;
        
        var viewport = page.getViewport({scale: scale_value });

        var canvas = document.getElementById("pdfcanvas");

       canvas.width = viewport.width;
       canvas.height = viewport.height;

        var render_context = {
            canvasContext: canvas.getContext('2d'),
            viewport: viewport
        };
            
        try 
        {
            var task = page.render(render_context)
              task.promise.then(function(){

                if (pGreyscale)
                {
                    let ctx = canvas.getContext('2d');
                    let imgData = ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height);
                    let pixels = imgData.data;
                    for (var i = 0; i < pixels.length; i += 4) {

                        let lightness = parseInt((pixels[i] + pixels[i + 1] + pixels[i + 2]) / 3);

                        pixels[i] = lightness;
                        pixels[i + 1] = lightness;
                        pixels[i + 2] = lightness;
                    }
                    ctx.putImageData(imgData, 0, 0);
                } 

                self.PDF_IMAGES[self.CurrentPageNo-1].data = canvas.toDataURL('image/jpeg',100).split(',').pop();
                self.PDF_IMAGES[self.CurrentPageNo-1].width = canvas.width;
                self.PDF_IMAGES[self.CurrentPageNo-1].height = canvas.height;


                self.PdfImagesOK_Count++;

                self.PromiseResultObject("OK");
              }).catch(function(){
                self.PromiseResultObject("KO");
              }
              );
                          
        }
        catch(error) {
            alert(error.message);
        }        


        return new Promise((resolve, reject) => {
          this.PromiseResultObject = resolve;
        });
    },

    async CreateUploadID()
    {
        var UploadID = "";

        var QP = {}

        var Q;
        await this.$refs.GRCDB.GetData("COMMON_FileUpload_CreateUploadID", QP).then(res => { Q = res; });

        //console.log("cruid err: "+Q.APPERR[0].ERR);

        if (Q.APPERR[0].ERR != "") { UploadID = ""; }
        else
        {
            if (Q.RESULT.length>0) { UploadID = Q.RESULT[0].UploadID; }

            //console.log("uid: "+UploadID);
        }

        return UploadID;
    },

    async UploadFiles(pUploadID, pFiles)
    {
        var Sikeres = true;

        for(var i=0; i<pFiles.length; i++)
        {
            if (Sikeres)
            {
                var QP = {
                    sUploadID: pUploadID,
                    iClientListID: pFiles[i].ClientListID,
                    iClientListParentID: pFiles[i].ClientListParentID,
                    sFileName: pFiles[i].FileName,
                    sExtension: pFiles[i].Extension,
                    sPassword: pFiles[i].Password,
                    iIsSigned: pFiles[i].IsSigned,
                    iImageWidth: pFiles[i].ImageWidth,
                    iImageHeight: pFiles[i].ImageHeight,
                    sDocData: pFiles[i].DocData,
                }

                //console.log(QP);

                var Q;
                await this.$refs.GRCDB.GetData("COMMON_FileUpload", QP).then(res => { Q = res; });

                //console.log("err: "+Q.APPERR[0].ERR);
                if (Q.APPERR[0].ERR != "") { Sikeres = false; }
            }
        }

        return Sikeres;
    },

  }  // end: methods



}
</script>

<style scoped>
    .cont
    {
        width:100%;
        box-sizing: border-box;
        padding:0px;
        margin: 0px;
        border:none;
        font-size: 1px;
        line-height: 1px;
        height: 0px;
        max-height: 0px;
        background-color: transparent;
    }
</style>